import React, { useState } from "react";
import { InputField, LoadingButton, TextButton } from "kubra-ux-forge";
import triangleWarning from "assets/icons/triangle_exclamation.svg";
import { getBiller } from "selectors";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { COMMON_NAMESPACE, EMAIL_VIEW } from "constants/i18n-namespaces";
import { PLATFORM_NAMESPACE } from "kubra-labels";
import { isEmail, postEmailWithInstanceId, postPayableEmailWithSpaceKrn } from "utilities/email-sms-util";

export interface IEmailViewProps {
  cancelHandler: (arg0: string) => void;
}

export const EmailView = (props: IEmailViewProps) => {
  const { cancelHandler } = props;
  const { t } = useTranslation(EMAIL_VIEW);
  const [success, setSuccess] = useState<string>("text");
  const [showInvalidEmail, setShowInvalidEmail] = useState(false);
  const [showEmptyEmail, setShowEmptyEmail] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const biller = useSelector(getBiller);  

  const updateEmailAddress = (e: string) => {
    setShowInvalidEmail(false);
    setShowEmptyEmail(false);
    setShowErrorMessage(false);
    setErrorState(false);
    setEmailAddress(e);
  };

  const sendEmail = async () => {
    if (!emailAddress || emailAddress.length === 0) {
      setShowEmptyEmail(true);
      setErrorState(true);
    }

    let apiSuccess;

    if (isEmail(emailAddress)) {
      setSuccess("loading");

      apiSuccess = (!(biller?.featureFlags?.accountV2) || biller?.featureFlags?.accountV2?.toLowerCase() === 'false') ?
       await postEmailWithInstanceId(biller, emailAddress) : await postPayableEmailWithSpaceKrn(biller, emailAddress)

      if (apiSuccess) {
        setSuccess("success");
      }
      else {
        setSuccess("text");
        setShowErrorMessage(true);
      }

    }
    else {
      setShowInvalidEmail(true);
    } 
    
  };

  let sentSuccess = false;
  if (success === "success") {
    sentSuccess = true;
  }

  return (
    <div data-cy="email-view">
      <div className="content-row">
        <InputField
          defaultValue=""
          errorText=""
          helperText=""
          label={`${t("email-label")}`}
          onChange={(e: { target: { value: string } }) =>
            updateEmailAddress(e.target.value)
          }
          hasError={errorState}
          title={`${t("email-title")}`}
          dataCy="title-email"
        />
        {showInvalidEmail && (
          <div>
            <img
              src={triangleWarning}
              alt="error"
              className="floatLeft"
              aria-hidden={true}
            />
            <div className="errorText">{t("email-invalid")}</div>
          </div>
        )}
        {showEmptyEmail && (
          <div>
            <img
              src={triangleWarning}
              alt="error"
              className="floatLeft"
              aria-hidden={true}
            />
            <div className="errorText">{t("email-required")}</div>
          </div>
        )}
        {showErrorMessage && (
          <div>
            <img src={triangleWarning} alt="error" className="floatLeft" />
            <div className="errorText">{t("error-sending-email")}</div>
          </div>
        )}
      </div>
      <div className="content-row">
        <div className="content-row-left-button">
          <TextButton
            onClick={() => cancelHandler("BarcodeView")}
            className="cancel-button"
            dataCy="button-cancel"
          >
            {t("cancelLabel", { ns: PLATFORM_NAMESPACE })}
          </TextButton>
        </div>
        <div className="content-row-right-button">
         
          <LoadingButton className="send-button" onClick={() => { sendEmail(); }} loadingState={success} variant="text"
            title="send button" dataCy="button-send"
          >
            {t("send", { ns: COMMON_NAMESPACE })}
          </LoadingButton>
        </div>
      </div>
      {sentSuccess && <div title="sent success"></div>}
    </div>
  );
}
